// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_tq5","rightAdornment":"Header_rightAdornment__1-C9R"};